import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { map, Observable, of } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';

import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { TokenStorageService } from '../../services/token-storage.service';
import { AUTH_PROVIDER_TOKEN, AuthProvider } from '../tokens/auth-provider.token';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class PreventLoginAccessGuard implements CanActivate {
  constructor(
    @Inject(AUTH_PROVIDER_TOKEN) private authProvider: AuthProvider,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private router: Router,
    private tokenStorageService: TokenStorageService,
    private msalService: MsalService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let isAuthenticated$: Observable<boolean>;

    if (this.authProvider === 'Entra') {
      const hasAccount = this.msalService.instance.getAllAccounts().length > 0;
      isAuthenticated$ = of(hasAccount);
    } else if (this.authProvider === 'Okta') {
      isAuthenticated$ = fromPromise(this.oktaAuth.isAuthenticated());
    } else {
      isAuthenticated$ = of(!!this.tokenStorageService.getAccessToken());
    }

    return isAuthenticated$.pipe(
      map((isAuthenticated: boolean) => {
        if (!isAuthenticated) {
          return true;
        }

        this.router.navigate(['']);
        return false;
      }),
    );
  }
}
